import React from "react";

const Loader = () => {
  return (
    <div>
      <div className="loader">
        <div className="spin"></div>
      </div>
    </div>
  );
};

export default Loader;
